import { SvgIcon } from '@material-ui/core'

export const VideoCameraIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M25.6667 10.4199C25.6667 9.71316 25.6667 9.35976 25.5269 9.19612C25.4056 9.05413 25.2237 8.97878 25.0376 8.99343C24.823 9.01032 24.5732 9.2602 24.0734 9.75998L19.8333 14L24.0734 18.24C24.5731 18.7398 24.823 18.9897 25.0376 19.0066C25.2237 19.0212 25.4056 18.9459 25.5269 18.8039C25.6667 18.6403 25.6667 18.2869 25.6667 17.5801V10.4199Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33334 11.4333C2.33334 9.47316 2.33334 8.49307 2.71482 7.74438C3.05038 7.08581 3.58581 6.55038 4.24438 6.21482C4.99307 5.83334 5.97316 5.83334 7.93334 5.83334H14.2333C16.1935 5.83334 17.1736 5.83334 17.9223 6.21482C18.5809 6.55038 19.1163 7.08581 19.4519 7.74438C19.8333 8.49307 19.8333 9.47316 19.8333 11.4333V16.5667C19.8333 18.5269 19.8333 19.507 19.4519 20.2556C19.1163 20.9142 18.5809 21.4496 17.9223 21.7852C17.1736 22.1667 16.1935 22.1667 14.2333 22.1667H7.93334C5.97316 22.1667 4.99307 22.1667 4.24438 21.7852C3.58581 21.4496 3.05038 20.9142 2.71482 20.2556C2.33334 19.507 2.33334 18.5269 2.33334 16.5667V11.4333Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
)
